import * as React from "react";
import { cn } from "../../../utils/cn";
import styles from "./Badge.module.css";

export type BadgeVariant =
  | "default"
  | "primary"
  | "secondary"
  | "outline"
  | "success"
  | "destructive"
  | "ghost";

export type BadgeSize = "default" | "icon";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
  variant?: BadgeVariant;
  size?: BadgeSize;
}

const Badge = ({
  className,
  variant = "default",
  size = "default",
  ...props
}: BadgeProps) => {
  const variantString = variant + "-var";
  const sizeString = size + "-size";

  return (
    <div
      className={cn(
        styles.badge,
        styles[variantString],
        styles[sizeString],
        className,
      )}
      {...props}
    />
  );
};

export { Badge, styles as BadgeStyles };
